import React from 'react';
import { useNavigate } from 'react-router-dom';
//import Teams from "./Teams.jsx"; // Asegúrate de que la ruta del archivo sea correcta y coincida con la ubicación real del archivo.
import Header from "./Header.jsx";
import Tarjetas from "./TarjetasServicios.jsx";
//import TeacherGallery from "./TeachersGallery.jsx";
import Teams from "./Teams.jsx";
import ContactForm from './ContactForm';


const Home = () => {
    const navigate = useNavigate();



  return (
    <main>
    <Header />
    <Tarjetas navigate={navigate} />

    <Teams />

    <section id="contacta" className="mbr-section-head reveal">
      <div className="container">
        <h3 className="mbr-section-title align-center mb-3 display-2"><strong>Contacta con asistai</strong></h3>
        <ContactForm />
      </div>
    </section>

    </main>
  );
};
export default Home;